import type { JSX } from "react";
import type { ClientPaginationState } from "./types";

/**
 * DataTable cell width constants (in pixels)
 * These widths must match the corresponding SCSS values in DataTable.module.scss
 */
export const DRAGGABLE_CELL_WIDTH = 18;
export const EXPAND_CELL_WIDTH = 34;
export const OVERFLOW_MENU_CELL_WIDTH = 45;
export const MULTI_SELECT_CELL_WIDTH = 30;
export const SUB_TABLE_PADDING_RIGHT = 18;
/** Minimum width for any column when resizing. Matches react-table's default minSize. */
export const MIN_COLUMN_WIDTH = 20;
/**
 * Extra pixels added when maximizing a column to fit its content. Guards against sub-pixel
 * flex rounding re-triggering the ellipsis right after the column is grown to fit.
 */
export const MAXIMIZE_COLUMN_BUFFER = 2;

/**
 * DataTable configuration constants
 */
export const OVERFLOW_MENU_ID = "overflow_menu";
export const DATA_TABLE_DEFAULT_PAGE_SIZE = 50;
export const MOBILE_WIDTH = 680;
export const DEFAULT_MIN_STARTING_WIDTH = 150;

export const DEFAULT_PAGINATION_STATE: ClientPaginationState = {
  pageSize: DATA_TABLE_DEFAULT_PAGE_SIZE,
  pageIndex: 0,
  pageInfoByIndex: {},
};

// Note: OVERFLOW_MENU_ID and DATA_TABLE_DEFAULT_PAGE_SIZE are exported above
// These were previously exported from DataTable.tsx and can still be imported from there
// but are now centralized in this constants file

/**
 * Pagination configuration
 */
export const PAGE_SIZES = [10, 20, 50, 100, 200];

/**
 * Controls configuration
 */
export const DATA_TABLE_CONTROLS_SELECTOR = "data-table-controls";

/**
 * Elements that can be clicked within table rows
 * Used to determine if row click should be prevented
 */
export const CLICKABLE_ELEMENTS: Uppercase<keyof JSX.IntrinsicElements>[] = ["INPUT", "BUTTON", "A", "LABEL"];
